import React from "react";
import {RouteObject} from "react-router-dom";
import OSPLayout from "../../layout/OSPLayout/OSPLayout";
import OspTrash from "../../pages/LADOSP/Trash/OspTrash";
import AddOsps from "../../pages/LADOSP/AddOSP/AddOsps";
import { UpdateOSPLayOut } from "../../layout/OSPLayout/SubLayout/ViewOSPLayOut/UpdateOSPLayOut";
import { UpdateOSP } from "../../pages/LADOSP/UpdateOSP/UpdateOSP";
import ViewBuyerDetails from "../../pages/LADOSP/ViewOSP/BuyerDetails/ViewBuyerDetails"
import PurchasedLeads from "../../pages/LADOSP/ViewOSP/PurchasedLeads/PurchasedLeads";
import SubscriptionPlan from "../../pages/LADOSP/ViewOSP/SubscriptionPlan/SubscriptionPlan";
import PurchasedHistory from "../../pages/LADOSP/ViewOSP/PurchasedHistory/PurchasedHistory";
import ReviewAndRatings from "../../pages/LADOSP/ViewOSP/ReviewAndRatings/ReviewsAndRatings";
import RFQsQuotes from "../../pages/LADOSP/ViewOSP/RFQsQuotes/RFQsQuotes";
import CommunicationHistory from "../../pages/LADOSP/ViewOSP/CommunicationHistory/CommunicationHistory";
import ViewOSPLayout from "../../layout/OSPLayout/SubLayout/ViewOSPLayOut/ViewOSPLayOut";

import AllActiveOSP from "../../pages/LADOSP/ActiveOSPList/AllActiveOSP";

import OSPSettings from "../../pages/LADOSP/OSPSettings/OSPSettings";


const OSPRoutes : RouteObject[] = [
    {
        path:'osp',
        element:<OSPLayout/>,
        children : [
             {
        index: true,
        element: <AllActiveOSP />,
      },
      {
        path: "all-active-osp",
        element: <AllActiveOSP/>,
      },
            {
                path: "add-osp",
                element: <AddOsps/>
            },
            {
                path: "osp-settings",
                element: <OSPSettings/>,
            },
            {
                path:"osp-trash",
                element: <OspTrash/>,
                children : [
                    {
                       path: "view-osp",
                       element: <ViewOSPLayout/>
                    }
                ]
            },
            
            
             
        ],
    },
    {
        path: "update-osp",
        element: <UpdateOSPLayOut/>,
        children : [
            {
                index: true,
                element : <UpdateOSP />,
            },
           {
        path: "update-osp",
        element: <UpdateOSP />,
      },

        ]
    },
    {
        path: "view-osp/",
        element:  <ViewOSPLayout/>,
        children: [
            {
                index: true,
                element: <ViewBuyerDetails/>,
            },
            {
                path:"buyer-details",
                element: < ViewBuyerDetails/>,
            },
             {
                  path: "purschase",
                element: <PurchasedLeads/>,
             },
               {
                  path: "purschase",
                element: <PurchasedLeads/>,
             },
             {
                path: "subscriptionplan",
                element: <SubscriptionPlan/>
             },
             {
                path: "purschasehistories",
                element: <PurchasedHistory/>
             },
              {
        path: "reviewratings",
        element: <ReviewAndRatings />,
      },
         {
        path: "rfqs",
        element: <RFQsQuotes />,
      },
      {
        path: "commmunication",
        element: <CommunicationHistory />,
      },
        ]
    }

]
export default OSPRoutes;